import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';

import { useDataStore } from 'state/DataStore';

const FeaturesContent = observer(({ colorScheme }) => {
    const dataStore = useDataStore();

    const featuresContent = colorScheme ? dataStore.getSetting('apartment_settings', `${colorScheme}_features`) : null;

    if (!featuresContent) {
        return (
            <p>No features content available.</p>
        );
    }

    return (
        <Inner>
            <Header className={colorScheme}>
                <HeaderTitle className="h3">
                    {colorScheme.charAt(0).toUpperCase() + colorScheme.slice(1)} Features
                </HeaderTitle>
            </Header>

            <Content>
                <FeaturesHtml dangerouslySetInnerHTML={{ __html: featuresContent }} />
            </Content>
        </Inner>
    );
});

export default FeaturesContent;

const Inner = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 2rem;
`;

const Header = styled.div`
    flex: 0 0 auto;
    padding: 3rem;
    margin-bottom: 2rem;
    text-align: center;

    &.penthouse {
        background-color: #ABC8B9;
    }
    &.platinum {
        background-color: #DAE2EB;
    }
    &.premium {
        background-color: #FAAA8D;
    }
`;

const HeaderTitle = styled.div`
    color: ${props => props.theme.primary_color};
    text-transform: uppercase;
`;

const Content = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 28rem;
`;

const FeaturesHtml = styled.div`
    column-count: 2;
    column-gap: 5rem;
    font-size: 1.6rem;

    ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    li ul {
        padding-top: 0.5rem;
    }

    li {
        --size: 1.5rem;
        --width: 3rem;

        margin-left: 0;
        padding-left: var(--width);
        padding-bottom: 0.5rem;
        break-inside: avoid;

        &::before {
            content: '\f00c';
            font-family: 'Font Awesome 7 Free';
            font-weight: 900;
            font-size: var(--size);
            line-height: 0;
            display: inline-block;
            width: 0;
            text-indent: calc((var(--width) / var(--size)) * -1em);
            vertical-align: middle;
            color: ${props => props.theme.secondary_color};
            position: relative;
            top: -.15em;
        }
    }

    li li {
        &::before {
            content: '\f068';
        }
    }
`;
